// src/pages/dashboard/AdminEarning.jsx
import React from "react";
import PageShell from "./PageShell";

export default function AdminEarning() {
  return <PageShell title="Earnings" />;
}

